import React from 'react';
import { Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerExecution } from '@/hooks/useManufacturingControlTower';

const ProductionExecutionMonitor: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerExecution({ page_size: 200, ...filters });
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <div>
      <Table
        size="small"
        loading={isLoading}
        rowKey="work_order_id"
        dataSource={rows}
        scroll={{ x: 1200 }}
        onRow={(r) => ({
          onClick: () => navigate(`/mfg/work-orders/${r.work_order_id}`),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'WO', dataIndex: 'work_order_number', width: 110 },
          { title: 'Customer', dataIndex: 'customer_name' },
          { title: 'Project', dataIndex: 'project_name' },
          { title: 'Scope', dataIndex: 'execution_scope', width: 120 },
          { title: 'Priority', dataIndex: 'priority', width: 80 },
          { title: 'Item', dataIndex: 'item_name', ellipsis: true },
          { title: 'Planned', dataIndex: 'planned_quantity', width: 80 },
          { title: 'Produced', dataIndex: 'produced_quantity', width: 80 },
          { title: 'Progress %', dataIndex: 'progress_percent', width: 90 },
          { title: 'Current op', dataIndex: 'current_operation', ellipsis: true },
          { title: 'Next op', dataIndex: 'next_operation', ellipsis: true },
          {
            title: 'Status',
            dataIndex: 'work_order_status',
            render: (s: string, r: Record<string, unknown>) => (
              <>
                <Tag>{s}</Tag>
                {r.is_delayed ? <Tag color="red">Late</Tag> : null}
              </>
            ),
          },
        ]}
        pagination={{ pageSize: 20 }}
      />
      <div style={{ marginTop: 8 }}>
        <a onClick={() => navigate('/mfg/work-order-operations')}>Open execution board</a>
        {' · '}
        <a onClick={() => navigate('/mfg/factory-floor')}>Factory floor</a>
      </div>
    </div>
  );
};

export default ProductionExecutionMonitor;
